var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 72,
    viewBox: "0 0 109 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.75 45.9167V12.0833C50.75 9.425 48.575 7.25 45.9167 7.25H12.0833C9.425 7.25 7.25 9.425 7.25 12.0833V45.9167C7.25 48.575 9.425 50.75 12.0833 50.75H45.9167C48.575 50.75 50.75 48.575 50.75 45.9167ZM20.5417 32.625L26.5833 39.8992L35.0417 29L45.9167 43.5H12.0833L20.5417 32.625Z",
    fill: "#5A6273"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6666 28.4987H55.8333V62.332C55.8333 64.9904 58.0083 67.1654 60.6666 67.1654H94.4999V62.332H60.6666V28.4987ZM99.3333 18.832H70.3333C67.6749 18.832 65.4999 21.007 65.4999 23.6654V52.6654C65.4999 55.3237 67.6749 57.4987 70.3333 57.4987H99.3333C101.992 57.4987 104.167 55.3237 104.167 52.6654V23.6654C104.167 21.007 101.992 18.832 99.3333 18.832ZM79.9999 49.0404V27.2904L94.4999 38.1654L79.9999 49.0404Z",
    fill: "#5A6273"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3aba12b4a324af95f02a9d7aaed04cc5.svg";
export { ForwardRef as ReactComponent };